import { Container } from 'inversify';
import type BaseApiProvider from 'providers/BaseApiProvider';
import AxiosApiProvider from 'providers/AxiosApiProvider';
import LocalStorageProvider from 'providers/LocalStorageProvider';
import repositoryContainer from 'repositories/inversify.config';
import catalogContainer from 'features/catalog/configs/inversify.config';

const container = new Container();
container.bind<BaseApiProvider>(Symbol.for("BaseApiProvider_2080")).toConstantValue(new AxiosApiProvider(process.env.REACT_APP_API_URL_2080!, LocalStorageProvider.getRadUserToken()));
container.bind<BaseApiProvider>(Symbol.for("BaseApiProvider_5080")).toConstantValue(new AxiosApiProvider(process.env.REACT_APP_API_URL_5080!, LocalStorageProvider.getUserToken()));
container.bind<BaseApiProvider>(Symbol.for("BaseApiProvider_5081")).toConstantValue(new AxiosApiProvider(process.env.REACT_APP_API_URL_5081!, LocalStorageProvider.getUserToken()));
container.load(repositoryContainer, catalogContainer);
export default container;
